"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnalyticsSkuViewed = exports.AnalyticsSkuViewedContext = exports.AnalyticsSkuViewed = void 0;

require("core-js/modules/es6.function.name.js");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactWaypoint = require("react-waypoint");

var _uuid = require("uuid");

var _Shibuya = require("../../Shibuya");

var _useConstant = require("../../hooks/useConstant");

var _index = require("../AnalyticsPageView/index");

var _ = require("..");

var _excluded = ["children"];
var AnalyticsSkuViewedContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.AnalyticsSkuViewedContext = AnalyticsSkuViewedContext;
var AnalyticsSkuViewed = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  // eslint-disable-next-line camelcase
  var _useSegmentAnalytics = (0, _.useSegmentAnalytics)(),
      analytics = _useSegmentAnalytics.analytics,
      deployable_name = _useSegmentAnalytics.deployable_name,
      deployable_version = _useSegmentAnalytics.deployable_version,
      deviceId = _useSegmentAnalytics.deviceId;

  var _useAnalyticsPageView = (0, _index.useAnalyticsPageView)(),
      pageViewId = _useAnalyticsPageView.pageViewId,
      pageName = _useAnalyticsPageView.pageName,
      pageViewReady = _useAnalyticsPageView.pageViewReady;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      skuViewedPayload = _useState2[0],
      setSkuViewedPayload = _useState2[1];

  var skuImpressionId = (0, _useConstant.useConstant)(function () {
    return (0, _uuid.v4)();
  });

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      viewed = _useState4[0],
      setViewed = _useState4[1];

  (0, _react.useEffect)(function () {
    if (pageViewReady && deviceId && viewed) {
      var eventPayload = {
        sku_id: props.id,
        sku_source: props.source,
        sku_name: props.name,
        sku_product_type: props.productType,
        sku_level: props.level,
        institution_id: props.institutionId,
        institution_name: props.institutionName,
        product_id: props.productId,
        product_name: props.productName,
        offer_id: props.offerId,
        offer_name: props.offerName,
        monetizable: props.monetizable,
        impression_page_name: pageName || '',
        impression_pageview_id: pageViewId,
        impression_section: props.impressionSection,
        impression_position: props.impressionPosition,
        impression_page_url: props.impressionPageUrl,
        sku_impression_id: skuImpressionId,
        deployable_name: deployable_name,
        deployable_version: deployable_version,
        traditional_device_id: deviceId
      };
      analytics === null || analytics === void 0 ? void 0 : analytics.track(_Shibuya.Shibuya.EventName.SKU_VIEWED, eventPayload);
      setSkuViewedPayload(eventPayload);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [pageViewReady, deviceId, viewed]);
  var context = {
    skuImpressionId: skuImpressionId,
    skuViewedPayload: skuViewedPayload
  };
  var child = typeof children === 'function' ? children(context) : children;

  if (!child) {
    throw new Error('Missing Child');
  }

  return /*#__PURE__*/_react.default.createElement(AnalyticsSkuViewedContext.Provider, {
    value: context
  }, /*#__PURE__*/_react.default.createElement(_reactWaypoint.Waypoint, {
    onEnter: function onEnter() {
      setViewed(true);
    }
  }, /*#__PURE__*/(0, _react.cloneElement)(child, {
    ref: ref
  })));
});
exports.AnalyticsSkuViewed = AnalyticsSkuViewed;

var useAnalyticsSkuViewed = function useAnalyticsSkuViewed() {
  var context = (0, _react.useContext)(AnalyticsSkuViewedContext);

  if (!context) {
    throw new Error('useAnalyticsSkuViewed must be used within AnalyticsSkuViewed');
  }

  return context;
};

exports.useAnalyticsSkuViewed = useAnalyticsSkuViewed;